import {
  BadgeCheck,
  CircleAlert,
  CircleDashed,
  CircleX,
  DatabaseZap,
} from "lucide-react";
import { useI18n } from "../i18n";
import type { SourceStatus } from "../shared/contracts";

const stateConfig = {
  connected: {
    className: "connected",
    icon: BadgeCheck,
  },
  missing_credentials: {
    className: "missing",
    icon: CircleDashed,
  },
  limited: {
    className: "limited",
    icon: CircleAlert,
  },
  error: {
    className: "error",
    icon: CircleX,
  },
} as const;

export function SourceRail({ sources }: { sources: SourceStatus[] }) {
  const { text } = useI18n();

  return (
    <aside className="source-rail">
      <div className="source-rail-heading">
        <DatabaseZap size={17} />
        <span>{text.sources.heading}</span>
      </div>
      <div className="source-list">
        {sources.map((source) => {
          const config = stateConfig[source.state];
          const StateIcon = config.icon;

          return (
            <div className="source-row" key={source.key} title={source.detail}>
              <div>
                <strong>{text.sources.labels[source.key] || source.label}</strong>
                <span>{text.sources.states[source.state]}</span>
              </div>
              <StateIcon
                size={16}
                className={`source-state ${config.className}`}
              />
            </div>
          );
        })}
      </div>
    </aside>
  );
}
